import { Box, Button, Stack, Typography } from "@mui/material";
import { ArrowClockwiseIcon } from "@phosphor-icons/react/dist/csr/ArrowClockwise";
import { HouseIcon } from "@phosphor-icons/react/dist/csr/House";
import { useNavigate } from "react-router-dom";

const AppError = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Stack direction="column" spacing={2} sx={{ p: 3, justifyContent: "center", alignItems: "center" }}>
        <Typography variant="heading.four">Uh-oh!</Typography>
        <span>Something went wrong. Please try again, or contact support if the problem persists.</span>
        <Stack direction="row" spacing={1} sx={{ justifyContent: "center", alignItems: "center" }}>
          <Button variant="outlined" startIcon={<ArrowClockwiseIcon />} onClick={() => window.location.reload()}>
            Refresh
          </Button>
          <Button startIcon={<HouseIcon />} variant="contained" onClick={() => navigate("/")}>
            Home
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export { AppError };
